
import React, { useState, useEffect, useRef, useCallback } from "react";
import cn from "classnames";
import Master from "screen/Master";
import styles from "./Alerts.module.scss";
import Button from "@material-ui/core/Button";
import { getRequest, postRequest } from "../../services/axiosBaseClient";
import styled from "styled-components";
import ReactTooltip from "react-tooltip";
import { InputGroup } from "react-bootstrap";
import NewTableAndSearchMasterFilter from "components/common/NewTableAndSearchMasterFilter";

var searchByKey = () => {};

var pageSize = 10;
var pageNumber = 0;
var pagingString = 'limit=' + pageSize + '&offset=' + pageNumber;
var tempTigger;

let multiselectArray = [];
function AlertsView(props) {
  const [filterData, setChargerMultiSelecct] = useState(multiselectArray);

  function useOutsideAlerter(ref) {
    useEffect(() => {
      /**
       * Alert if clicked on outside of element
       */
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          setOpen(false);
          // alert("You clicked outside of me!");
        } else {
          setOpen(true);
        }
      }

      // Bind the event listener
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        // Unbind the event listener on clean up
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  }

  const wrapperRef = useRef(null);
  useOutsideAlerter(wrapperRef);
  const [open, setOpen] = React.useState(false);
  const handleClick = () => {
    if (open) {
      setOpen(false);
    } else {
      setOpen(true);
    }
  };

  // const [open, setOpen] = React.useState(false);
  const [droppedFilter, setDroppedFilter] = useState(false);
  const [siteCount, setSiteCount] = useState(3);
  const [alertData, setAlertData] = useState();
  const [count, setCount] = useState([]);
  const [swapStationCount, setSwapStationCount] = useState("");
  const swappedSessionData = [];

  const getAlertData = useCallback(async () => {
    await getRequest("bss/getAlerts/filter?")
      .then((res) => {
        if (res && res?.data) {
          setAlertData(res?.data);
        }
      })
      .catch((err) => {
        console.error("Error", err);
      });
  }, []);

  const pageLimitHandle = (offsett, limit, tigger, tempHeaderFilter) => {
    tempTigger = tigger;
    const testCount = tigger == "amhitted" ? 1 : offsett;
    pageNumber = offsett;
    pageSize = limit
    // searchSwapStationByFilter(tempHeaderFilter);
  };
  
  const paginationCountHanlde = (offsett, limit, tigger, tempHeaderFilter) => {
    tempTigger = tigger;
    const testCount = tigger == "amhitted" ? 1 : offsett;
    // pageNumber = offsett;
    pageNumber = offsett;
    pageSize = limit;
    // searchSwapStationByFilter(tempHeaderFilter);
  };

  const getHeaderAlertCount = useCallback(async () => {
    const isAlertSeen = true;
    await getRequest(`bss/getUnreadAlert?isAlertSeen=${isAlertSeen}`)
      .then((res) => {
        // if (res && res.status === 404) {
        // setAlertUnreadCount(res?.data);
        // }
      })
      .catch((err) => {
        // setAlertUnreadCount(res?.data);
        console.log(err, "ERROR");
      });
  }, []);

  useEffect(() => {
    getHeaderAlertCount();
  }, []);

  const searchingByName = useCallback(async (filter, searchString) => {
    if (searchString === undefined) {
      await getAlertData();
      return;
    }
    await getRequest("bss/getAlerts/filter?description=" + searchString)
      .then((res) => {
        if (res && res?.data) {
          setAlertData(res?.data);
        }
      })
      .catch((err) => {
        console.error("Error", err);
      });
  });

  const searchSwapStationByFilter = (searchString) => {
    //topSites=False&timeFilterEnum=HOUR_12

    // if (searchString === undefined || searchString === "")
    //   return getAlertData();
    getRequest("bss/getAlerts/filter?" + searchString)
      .then((res) => {
        if (res && res?.data) {
          setAlertData(res?.data);
          setSwapStationCount(res?.data?.alertCount);
        }
      })
      .catch((err) => {});
  };
  const getCount = useCallback(async () => {
    await getRequest("bss/getAlertsHeaderInformation")
      .then((res) => {
        if (res && res?.data) {
          setCount(res?.data);
        }
      })
      .catch((err) => {
        console.error("Error", err);
      });
  }, []);

  useEffect(() => {
    getCount();
  }, []);

  const columns = React.useMemo(() => [
    {
      Header: "Id",
      accessor: "id",
    },
    {
      Header: "Asset Type",
      accessor: "assetType",
      Cell: (row) => { 
        return(
          <div>{row.row?.original?.assetType? row.row?.original?.assetType : 'NA'}</div>
      ) },
    },
    {
      Header: "Alert Type",
      accessor: "alertType",
      Cell: (row) => {
        return (
          <>
            {row.row.original.alertType === "Fault" ? (
              // row?.alertType ==='Alerts'
              <p className={cn(styles.Alert1)}>
                <span>Fault</span>
              </p>
            ) : row.row.original.alertType === "Temperature" ? (
              <p className={cn(styles.Alert1, styles.Alert2)}>
                <span>Temperature</span>
              </p>
            ) : // row?.alertTypes=== 'Upcomming'
            row.row.original.alertType === "Upcoming Swapping" ? (
              <p className={cn(styles.Alert1, styles.Alert3)}>
                <span>Upcoming</span>
              </p>
            ) : row.row.original.alertType === "Warn" ? (
              <p className={cn(styles.Alert1, styles.Alert4)}>
                <span>Warn</span>
              </p>
            ) : (
              <p className={cn(styles.Alert1, styles.Alert5)}>
                <span>Error</span>
              </p>
            )}
          </>
        );
      },
    },
    {
      Header: "Swapping Station Name",
      accessor: "swappingStationName",
      Cell: (row) => { 
        return(
          <div>{row.row?.original?.swappingStationName? row.row?.original?.swappingStationName : 'NA'}</div>
      ) },
    },
    {
      Header: "Slot Name",
      accessor: "slotName",
      Cell: (row) => { 
        return(
          <div style={{ paddingLeft:"25px" }}>{row.row?.original?.slotName? row.row?.original?.slotName : 'NA'}</div>
      ) },
    },
    {
      Header: "Battery Serial Number",
      accessor: "batterySerialNumber",
      Cell: (row) => { 
        return(
          <div style={{ paddingLeft:"10px" }}>{row.row?.original?.batterySerialNumber? row.row?.original?.batterySerialNumber : <span style={{ paddingLeft : '30px'}}>NA</span>}</div>
      ) },
    },
    {
      Header: "Zone Name",
      accessor: "zoneName",
      Cell: (row) => { 
        return(
          <div>{row.row?.original?.zoneName? row.row?.original?.zoneName : 'NA'}</div>
      ) },
    },
    {
      Header: "Site Name",
      accessor: "siteName",
      Cell: (row) => { 
        return(
          <div>{row.row?.original?.siteName? row.row?.original?.siteName : 'NA'}</div>
      ) },
    },
    {
      Header: "Description",
      accessor: "description",
      Cell: (row) => {
        return (
          <>
            <div data-for="main" data-tip={row.row.original.description}>
              {row.row?.original?.description? row.row.original.description : 'NA'}
            </div>
            <ReactTooltip id="main" type="light" />
          </>
        );
      },
    },
    {
      Header: "Status",
      accessor: "status",
      Cell: (row) => {
        return (
          <>
            {row.row.original.status === "true" ? (
              <p className={cn(styles.Status1)}>
                <span>Active</span>
              </p>
            ) : (
              ""
            )}

            {row.row.original.status === "false" ? (
              <p className={cn(styles.Status1, styles.Status2)}>
                <span>Inactive</span>
              </p>
            ) : (
              ""
            )}
          </>
        );
      },
    },
    {
      Header: "Timestamp",
      accessor: "timestamp",
      Cell: (row) => { 
        return(
          <div>{row.row?.original?.timestamp? row.row?.original?.timestamp : 'NA'}</div>
      ) },
    },
  ]);

  const checkNumber = (obj) => {
    if (obj && typeof parseInt(obj) === "number") {
      return obj;
    } else {
      return 0;
    }
  };

  alertData?.alertList?.map((item) => {
    swappedSessionData.push({
      id: item?.id,
      assetType: item?.assetType,
      alertType: item?.alertType,
      zoneName: item?.zoneName,
      slotName: item?.slotName,
      swappingStationName: item?.swappingStationName,
      batterySerialNumber: item?.batterySerialNumber,
      siteName: item?.siteName,
      description: item?.description,
      status: item?.status,
      timestamp: item?.timestamp,
    });
  });

  return (
    <>
      <h2 id="header_text" className={cn(styles.medium_title, styles.medium_title_layout)}>
        {"Alerts"}
      </h2>
      <div id="header_layout" className={cn(styles.flex2, styles.flex2_layout2)}>
        <div id="header_box_div" className={cn(styles.header)}>
          <div id="header_box1" className={cn(styles.box1)}>
            <div id="header_innerbox" className={cn(styles.Innerbox)}>
              <div id="circle" className={cn(styles.circle)}>
                <img id="bell_img"
                  src={require("assets/bell.png").default}
                  // alt="Rectangle 16663"
                  className={cn(styles.bell)}
                />
              </div>

              <div id="text_area">
                <div id="total_alert_text" className={cn(styles.text1)}>{"Total Alerts"}</div>
                <div id="total_alert_count" className={cn(styles.text2)}>
                  {checkNumber(count.alerts)}
                </div>
              </div>
            </div>
          </div>

          <div id="header_box2" className={cn(styles.box1, styles.box2)}>
            <div id="header_innerbox" className={cn(styles.Innerbox)}>
              <div id="circle" className={cn(styles.circle)}>
                <img id="error_img"
                  src={require("assets/error.png").default}
                  // alt="Rectangle 16663"
                  className={cn(styles.bell)}
                />
              </div>

              <div id="text_area">
                <div id="total_fault_text" className={cn(styles.text1)}>{"Faults"}</div>
                <div id="total_fault_count" className={cn(styles.text2)}>
                  {checkNumber(count.faults)}
                </div>
              </div>
            </div>
          </div>

          <div id="header_box3" className={cn(styles.box1, styles.box3)}>
            <div id="header_innerbox" className={cn(styles.Innerbox)}>
              <div id="circle" className={cn(styles.circle)}>
                <img id="temperature_img"
                  src={require("assets/temperature.png").default}
                  // alt="Rectangle 16663"
                  className={cn(styles.bell)}
                />
              </div>

              <div id="text_area">
                <div id="total_temperature_text" className={cn(styles.text1)}>{"Temperature"}</div>
                <div id="total_temperature_count" className={cn(styles.text2)}>
                  {checkNumber(count.temperature)}
                </div>
              </div>
            </div>
          </div>

          <div id="header_box4" className={cn(styles.box1, styles.box4)}>
            <div id="header_innerbox" className={cn(styles.Innerbox)}>
              <div id="circle" className={cn(styles.circle)}>
                <img id="charging_img"
                  src={require("assets/charging.png").default}
                  // alt="Rectangle 16663"
                  className={cn(styles.bell)}
                />
              </div>

              <div id="text_area">
                <div id="total_swapping_text"
                 
                  className={cn(styles.text1)}
                >
                  {"Upcoming Swapping"}
                </div>
                <div id="total_swapping_count" className={cn(styles.text2)}>
                  {checkNumber(count.upcomingSwaps)}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className={cn(styles.block8, styles.block8_layout)}>
        <div className={cn(styles.block8_item)}>
          <div className={cn(styles.block23, styles.block23_layout)}>
            <div className={cn(styles.box10, styles.box10_layout)} />
            <div className={cn(styles.box11, styles.box11_layout)}>
              <>
                <img
                  src={require("assets/alertsTotalcount.svg").default}
                  style={{
                    marginLeft: "7px",
                    marginTop: "6px",
                    cursor: "pointer",
                  }}
                />
              </>
            </div>
          </div>
        </div>
        <div className={cn(styles.block8_spacer)} />
        <div className={cn(styles.block8_item1)}>
          <div
            className={cn(
              styles.swapping_header_count_container,
              styles.block21_layout
            )}
          >
            <div className={cn(styles.block22, styles.block22_layout)}>
              <h3 id="alert_total_count_text" className={cn(styles.subtitle2, styles.subtitle2_layout)}>
                {"Total Count"}
              </h3>
            </div>

            <div id="alert_total_count_value"
              className={cn(
                styles.small_text_body1,
                styles.small_text_body1_layout
              )}
            >
              {swapStationCount}
            </div>
            <div
              className={cn(
                styles.small_text_body1,
                styles.small_text_body1_layout1
              )}
            >
              {""}
            </div>
          </div>
        </div>
      </div>

      {/* <Table columns={columns} data={data} /> */}

      <NewTableAndSearchMasterFilter
        searchOpts={{
          placeholder: "Search by description",
          filter: true,
          onFilterSearch: searchSwapStationByFilter,
          screentype: "swapping",
          addInvoice: false,
        }}
        headerFilter={props.headerFilter}
        columns={columns}
        paginationDoubleScreen={true}
        data={swappedSessionData}
        swapStationCount={swapStationCount}
        pageLimitHandle={pageLimitHandle}
        paginationCountHanlde={paginationCountHanlde}
        _id={"alert"}
      />
    </>
  );
}

export default function Alerts(props) {
  const [headerFilter, setHeaderFilter] = useState(true);

  return (
    <>
      <Master
        opts={props}
        screen={AlertsView}
        showStatus={false}
        headerFilter={headerFilter}
        setHeaderFilter={setHeaderFilter}
      />
    </>
  );
}
Alerts.inStorybook = true;
